import { FetchResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { trans } from '@/helpers/trans'
import { generateApiV3Url } from '@/helpers/url'

import { ChatConversationResource } from './ChatConversation'

/**
 * Starts a direct conversation with the given user, or resumes the existing one.
 * Resolves to the Stream channel id of the conversation.
 */
export const startChatConversationApiCall = async (userUuid: string): Promise<FetchResult<string, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/stream/conversations/${userUuid}` })
        const response = await authorizedFetch(url, { method: 'POST' })

        if (! response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const resource: ChatConversationResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: resource.channel_id,
        }
    } catch (error) {
        console.error('[startChatConversationApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
